module.exports = __webpack_public_path__ + "img/0.54d5afc5.png";